import React from "react";
import {
  Modal,
  ModalProps,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Box,
  useMediaQuery,
} from "@chakra-ui/react";

interface Props extends Omit<ModalProps, "children"> {
  src: string;
}

const ModalWatchVideo = ({ src, ...otherProps }: Props) => {
  const [isDesktop] = useMediaQuery("(min-width: 1024px)");

  return (
    <Modal {...otherProps} isCentered={!isDesktop}>
      <ModalOverlay />
      <ModalContent maxW={["90vw", null, null, null, null, "980px"]}>
        <ModalCloseButton
          zIndex={2}
          top={0}
          right={0}
          background="#fff"
          borderRadius="50%"
          transform="translate(50%, -50%)"
          _hover={{ background: "#fff" }}
        />
        <Box
          pos="relative"
          height="100vh"
          maxH={["60vw", null, null, null, null, "650px"]}
        >
          <iframe width="100%" height="100%" src={src} frameBorder="0" />
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default ModalWatchVideo;
